export default __webpack_public_path__ + "static/media/c5.040564a1.png";